import { AiTicketingFeatureDocument } from 'generated/resources/graphql'
import { useQuery } from 'modules/core/hooks/useQuery'

interface UseAiTicketingFeatureResult {
  loading: boolean
  enabled: boolean
}

export const useAiTicketingFeature = (): UseAiTicketingFeatureResult => {
  const { data, loading } = useQuery(AiTicketingFeatureDocument)

  const enabled = Boolean(
    data?.permissions.contextlessPolicyResolutions?.find(
      (resolution) => resolution.id === 'Ticketing_aiFeatures'
    )?.can
  )

  return { loading, enabled }
}
